import { useState } from "react";

import Layout from "/Layout";
import ContactCard from "/components/Projects/ContactCard";
import ProjectsList from "/components/Projects/List";

export default function CollectionShow({
  sourceURL,
  locale,
  collection,
}) {
  return (
    <Layout>
      <ProjectsList sourceURL={sourceURL} />
      {collection.contact && (
        <ContactCard contact={collection.contact} />
      )}
    </Layout>
  );
}
